export enum ServiceType {
  GiftWrapping = 'GIFT_WRAPPING',
  Engraving = 'ENGRAVING',
}
